import type { Products } from '@forest/native-services'

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export type ChinaTrialEligibility = 'pending' | 'available' | 'unavailable'

export interface Input {
  platform: Platform
  products: Products | null
  chinaAndroidTrialEligibility: ChinaTrialEligibility
}

export type SkuKey = 'annualEarlyBird' | 'monthlyEarlyBird' | 'monthlyNoTrial'

export type Variant =
  | { kind: 'loading' }
  | { kind: 'china-trial-cta' }
  | { kind: 'two-plans'; left: SkuKey; right: SkuKey }
  | { kind: 'error' }

export function selectPlanVariant(input: Input): Variant {
  if (!input.products) return { kind: 'loading' }

  if (input.platform === 'china_android') {
    if (input.chinaAndroidTrialEligibility === 'pending') {
      return { kind: 'loading' }
    }
    if (input.chinaAndroidTrialEligibility === 'available') {
      return { kind: 'china-trial-cta' }
    }
    return {
      kind: 'two-plans',
      left: 'annualEarlyBird',
      right: 'monthlyEarlyBird',
    }
  }

  const annualTrialEligible =
    (input.products.annualEarlyBird.eligible_trial_days ?? 0) > 0
  if (annualTrialEligible) {
    if (input.products.monthlyNoTrial == null) {
      return { kind: 'error' }
    }
    return {
      kind: 'two-plans',
      left: 'annualEarlyBird',
      right: 'monthlyNoTrial',
    }
  }
  return {
    kind: 'two-plans',
    left: 'annualEarlyBird',
    right: 'monthlyEarlyBird',
  }
}
